import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { FileImageOutlined } from '@ant-design/icons';
import ViewImagesModal from './ViewImagesModal';

const ViewImagesButton = ({ imei }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleOpen = () => {
    if (imei) {
      setIsVisible(true);
    }
  };

  return (
    <>
     <Tooltip title="View Images">
      <Button type="primary" onClick={handleOpen}
        icon={<FileImageOutlined />} >
      </Button>
      </Tooltip>
      {imei && (
        <ViewImagesModal
          imei={imei}
          isVisible={isVisible}
          onClose={() => setIsVisible(false)}
        />
      )}
    </>
  );
};

export default ViewImagesButton;
